import { Box } from "@mui/material";
import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import RiskAppetiteStatusPill from "../../../risk/riskAppetiteStatusPill/RiskAppetiteStatusPill";
import WhiteDashboardBox from "../../WhiteDashboardBox";

export interface IRiskAppetiteBoxProps {
    isLoading: boolean;
    riskAppetiteLimit: number;
    risksOverAppetite: number;
    isExceeded: boolean;
}

// The management report's appetite card restated for the dashboard: same numbers, same wording, same pill, but as a
// white box in the widget's dark blue text rather than the report's dark blue card. The count is access-filtered while
// the limit is a customer-level setting, so a restricted user can read "within appetite" even when the customer as a
// whole is over it — the price of every figure in this widget narrowing with the dashboard's own filters.
function RiskAppetiteBox({ isLoading, riskAppetiteLimit, risksOverAppetite, isExceeded }: IRiskAppetiteBoxProps) {
    const { translateString, translateNumber } = useTranslation();

    return (
        <WhiteDashboardBox marginTop={1} isLoading={isLoading}>
            <DotLegalHeader marginBottom={1} headerStyle={"small"}>
                {translateString("riskManagementReportAppetiteLimit", { limit: translateNumber(riskAppetiteLimit) })}
            </DotLegalHeader>

            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                <Box sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
                    <DotLegalHeader marginBottom={0} fontWeight={400} headerStyle={"extraLarge"}>
                        {translateNumber(risksOverAppetite)}
                    </DotLegalHeader>
                    {/*<Box sx={(theme) => ({ fontSize: theme.typography.pxToRem(28), fontWeight: theme.typography.fontWeightLight, lineHeight: 1 })}>
                        {translateNumber(risksOverAppetite)}
                    </Box>*/}
                    <DotLegalHeader marginBottom={0} fontWeight={400} headerStyle={"small"}>
                        {translateString("riskManagementReportRisksAboveAppetite")}
                    </DotLegalHeader>
                    {/*<Box sx={(theme) => ({ fontSize: theme.typography.pxToRem(14) })}>{translateString("riskManagementReportRisksAboveAppetite")}</Box>*/}
                </Box>

                <RiskAppetiteStatusPill isExceeded={isExceeded} />
            </Box>
        </WhiteDashboardBox>
    );
}

export default RiskAppetiteBox;
